import { useState } from "react";
import { categories, newsList } from "@/mocks/chiGuaData";
import NewsCard from "./NewsCard";

export default function CategoryBrowse() {
  const [active, setActive] = useState("all");

  const list =
    active === "all" ? newsList : newsList.filter((n) => n.category === active);

  return (
    <section id="browse" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500/15 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-grid-fill" aria-hidden="true"></i> 分类浏览
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            按你喜欢的分类，快速找话题
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            切换分类即可查看对应板块的新鲜内容，浏览推荐更贴合你的口味。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {categories.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => setActive(c.key)}
              className={`whitespace-nowrap rounded-full px-1 py-1 ${
                active === c.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-500/15"
              }`}
            >
              <span className="px-4 py-2 text-sm font-medium">{c.name}</span>
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.length > 0 ? (
            list.map((item) => <NewsCard key={item.id} item={item} />)
          ) : (
            <p className="col-span-full rounded-lg bg-background-100 py-12 text-center text-sm text-foreground-600">
              该分类下暂时没有内容，去「今日新鲜」看看吧。
            </p>
          )}
        </div>
      </div>
    </section>
  );
}